(() => {
    "use strict"

    const header = document.getElementById('header')
    const hero = document.getElementById('hero')

    // Using declarative JS to handle user interactions with the UI
    document.addEventListener('click', evt => {
        const uiElement = evt.target

        // Toggle visibility of a hidden element tied to ui element, e.g. nav toggle button, faq, etc.
        if (uiElement.dataset.action) {
            switch (uiElement.dataset.action) {
                case 'toggle':
                    toggle(uiElement)
                    break
            }
        }
    })

    document.addEventListener('focusin', evt => {
        const uiElement = evt.target

        if (uiElement.dataset.action) {
            switch (uiElement.dataset.action) {
                case 'invert':
                    invert(uiElement)
                    break
            }
        }
    })

    document.addEventListener('focusout', evt => {
        const uiElement = evt.target
        const isLast = Boolean(uiElement.dataset.last) ?? false

        if (uiElement.dataset.action) {
            switch (uiElement.dataset.action) {
                case 'invert':
                    invert(uiElement)
                    break
            }
        }

        if (isLast && header.classList.contains('is-active')) {
            toggle(document.getElementById('nav-menu-toggle'))
        }
    })

    // Listen for 'Esc' key press and remove all active states
    document.addEventListener('keydown', evt => {
        if (evt.key === 'Esc' || evt.key === 'Escape') {
            document.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'))
        }

        // Add more keydown events here as needed
        // ...
    })

    if (document.querySelector('[data-aos]')) {
        AOS.init({
            offset: 50,
            duration: 1200,
        })
    }

    // ---------------------------------------------------------- //
    /*              REUSABLE FUNCTIONS FOR THE UI                 */
    // ---------------------------------------------------------- //

    /**
     * Toggle visibility of the hidden element
     * @param {*} el 
     */
    const toggle = (el) => {
        const targets = el.dataset.target.split('|')
        if (targets.length == 0) return

        targets.forEach(target => {
            if (target === 'nav') {
                // Take the header height and adjust the nav element distance from the top of the viewport
                const header = document.getElementById('header')
                document.querySelector(`[data-element="${target}"]`).style.top = header.offsetHeight + 'px'

                // Invert the logo
                const logo = document.querySelector('.logo')
                invert(logo)
            }

            document.querySelector(`[data-element="${target}"]`).classList.toggle('is-active')
        })

        el.classList.toggle('is-active')
    }

    /**
     * Invert element
     * @param {*} el 
     */
    const invert = (el) => {
        const isActive = el.classList.toggle('invert')
        const img = el.querySelector('img')

        if (img && img.dataset.invert) {
            // Store the original src only once
            if (!img.dataset.original) {
                img.dataset.original = img.getAttribute('src')
            }

            // Toggle between original and invert paths
            img.src = isActive ? img.dataset.invert : img.dataset.original
        }
    }
})()